import React from 'react'
import LiveEventControlPage from './modules/LiveEventControlPage'

const LiveEventControl = () => {
  return <LiveEventControlPage />
}

export default LiveEventControl;
